import { render } from "./App.vue?vue&type=template&id=166dc42c&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=166dc42c&scoped=true&lang=css"
/* custom blocks */
import block0 from "./App.vue?vue&type=custom&index=0&blockType=i18n&locale=de&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "./App.vue?vue&type=custom&index=1&blockType=i18n&locale=en&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/runner/work/partmate/partmate/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166dc42c"]])

export default __exports__